import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FieldDescriptionInheritedFragmentGql } from './FieldDescriptionInheritedFragmentGql';
import { FieldIconFragmentGql } from './FieldIconFragmentGql';

/* This query is used on the same page as DatasourceFieldsByIdQueryGql is. If you modify this query, please also modify
 * the other to accommodate the feature flag being both on and off.
 */
export const DatasourceFieldsWithInheritanceByIdQueryGql: DocumentNode = gql`
query DatasourceFieldsWithInheritanceByIdQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FieldSortOrder!) {
  publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
    id
    name
    vizportalUrlId
    fieldsConnection(filter: { isHidden: false }, first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        id
        name
        ...FieldDescriptionInheritedFragment
        downstreamSheetsConnection {
          totalCount
        }
        ...FieldIconFragment
      }
    }
  }
}
${FieldIconFragmentGql}
${FieldDescriptionInheritedFragmentGql}
`;
